module.exports = __webpack_public_path__ + "media/1x1/gg-357e1e33.svg";